import { AccordionDetails, AccordionSlots, AccordionSummary, Fade, Typography, Accordion } from "@mui/material";
import React from "react";
import { TaskCard } from "./taskCard";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { useTranslation } from "react-i18next";
import { ProjectTaskDashboard } from "../../../../interfaces/Projects/projectTaskDashboard";
import { Menuitem } from "../../../../interfaces/Security/menu";
import { FieldType } from "../../../../interfaces/Projects/Catalogs/fieldTypes";

type TaskAccordionProps = {
  title: string;
  tasks: ProjectTaskDashboard[];
  color: number[] | undefined;
  isEdit: boolean;
  expanded: boolean,
  setExpandedAccordion: React.Dispatch<React.SetStateAction<string | false>>,
  identifier: string
  resourceScreen: Menuitem;
  comboFieldTypes: FieldType[]
};

export const TaskAccordion = ({
  title,
  tasks,
  color,
  isEdit,
  expanded,
  setExpandedAccordion,
  identifier,
  resourceScreen,
  comboFieldTypes
}: TaskAccordionProps) => {

  const [t] = useTranslation("global");

  const handleExpansion = () => {
    setExpandedAccordion(expanded ? false : identifier);
  };

  return (
    <div>
      <Accordion
        expanded={expanded}
        onChange={handleExpansion}
        slots={{ transition: Fade as AccordionSlots['transition'] }}
        slotProps={{ transition: { timeout: 400 } }}
        sx={[
          {
            boxShadow: 'none',
            border: 'none',
            borderBottom: '1px solid #e0e0e0',
          },
          expanded
            ? {
              '& .MuiAccordion-region': {
                height: 'auto',
              },
              '& .MuiAccordionDetails-root': {
                display: 'block',
              },
            }
            : {
              '& .MuiAccordion-region': {
                height: 0,
              },
              '& .MuiAccordionDetails-root': {
                display: 'none',
              },
            },
        ]}

      >
        <AccordionSummary

          expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: 16 }} />}
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            gap: 2
          }}
        >
          <Typography fontWeight="bold">{title}</Typography>
          <Typography marginLeft={1}>{tasks.length}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {tasks.length > 0 ? (
            tasks.map((task) => (
              <TaskCard
                key={task.project_task_id}
                task={task}
                color={color}
                isEdit={isEdit}
                resourceScreen={resourceScreen}
                comboFieldTypes={comboFieldTypes}
              />
            ))
          ) : (
            <Typography>{t('projecttaskdashboard.messages.no-tasks')}</Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
